import { CircleUserRound } from "lucide-react";
import { ChromeBar } from "./ChromeBar";

/* The frame every Me screen sits in: the section bar, then the screen. Her ask,
   2026-10-14 — Business, Voice, Skills, Bio and Brand had no bar, so they did
   not read as part of Brill, and had no light/dark switch or Library button.
   The screens below it keep their own heading and Saved read-out; the bar names
   the SECTION, the heading names the screen.

   CircleUserRound is the Me row's icon in the sidebar, so the bar and the nav
   agree. The rule is the chrome accent (teal) — Momentum's is amber. */
export const ME_SCREENS = ["me_business", "me_voice", "me_writing", "me_skills", "me_bio", "me_brand"];

export function MeFrame({ isMobile, onMenuOpen, onLibrary, children }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, height: "100%", overflow: "hidden", minWidth: 0 }}>
      <ChromeBar icon={CircleUserRound} title="Me" subtitle="Business · Voice · Skills · Bio · Brand" rule="var(--chrome-accent)"
        isMobile={isMobile} onMenuOpen={onMenuOpen} onLibrary={onLibrary} />
      {children}
    </div>
  );
}
